import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import * as ImageActions from '../actions/image.actions';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';

@Injectable()
export class ImageEffects {

  loadImages$ = createEffect(() => {
    return this.actions$.pipe( 

      ofType(ImageActions.loadProfileImage),
      concatMap(() =>
      this._imageUpload.onGetProfileLogo().pipe(
          map(data => {
            
            return ImageActions.loadProfileImageSuccess({ image: data.image })
          }),
          catchError(error => of(ImageActions.loadProfileImageFailure({ error }))))
      )
    );
  });

  storeProfileImage$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(ImageActions.storeProfileImage),
      switchMap((action) =>
        this._imageUpload.onPostProfileImage(action.data).pipe(
          map(data => ImageActions.storeProfileImageSuccess({ image: data.image })),
          catchError(error => of(ImageActions.storeProfileImageFailure({ error }))))
      )
    );
  });

  removeProfileImage$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(ImageActions.removeProfileImage),
      switchMap((action) =>
      this._imageUpload.onDeleteProfileLogo().pipe(
          map(data => ImageActions.removeProfileImageSuccess({ image: data.image })),
          catchError(error => of(ImageActions.removeProfileImageFailure({ error }))))
      )
    );
  });

 


  constructor(private actions$: Actions, private _imageUpload: ImageUploadService) {}

}
